// extracted by mini-css-extract-plugin
export default {"input":"GhX1oPovx60SBqLAcIRO","compact":"e_ajyzzYMoPVaBhP_BDQ"};